document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidad();
  initParallaxHero();
});

function initParallaxHero() {
  var wraps = document.querySelectorAll('[data-mt-parallax]');
  if (!wraps.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function update() {
    wraps.forEach(function (wrap) {
      var img = wrap.querySelector('[data-mt-parallax-img]');
      if (!img) return;
      var rect = wrap.getBoundingClientRect();
      var progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      var offset = (progress - 0.5) * 40;
      img.style.transform = 'scale(1.08) translateY(' + offset.toFixed(1) + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
  update();
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  if (!items.length) return;
  items.forEach(function (item) {
    var boton = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = item.getAttribute('data-abierto') === 'true';
      items.forEach(function (otro) {
        otro.setAttribute('data-abierto', 'false');
        var r = otro.querySelector('.mt-faq__respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.setAttribute('data-abierto', 'true');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var flechaPrev = galeria.querySelector('[data-mt-flecha="prev"]');
  var flechaNext = galeria.querySelector('[data-mt-flecha="next"]');
  var contador = galeria.querySelector('[data-mt-contador]');
  if (!principal) return;

  var imagenes = [];
  try { imagenes = JSON.parse(galeria.getAttribute('data-mt-imagenes') || '[]'); } catch (e) { imagenes = []; }
  if (!imagenes.length || !flechaPrev || !flechaNext) return;

  var indice = Math.max(0, imagenes.indexOf(principal.src));
  if (indice === -1) indice = 0;

  function actualizarContador() {
    if (contador) contador.textContent = (indice + 1) + ' / ' + imagenes.length;
  }

  function irA(nuevoIndice, direccion) {
    indice = (nuevoIndice + imagenes.length) % imagenes.length;
    var src = imagenes[indice];
    if (!src) return;
    principal.classList.add('mt-fundido', 'mt-fundido--' + direccion);
    window.setTimeout(function () {
      principal.src = src;
      window.requestAnimationFrame(function () {
        principal.classList.remove('mt-fundido', 'mt-fundido--' + direccion);
      });
    }, 200);
    actualizarContador();
  }

  flechaPrev.addEventListener('click', function () { irA(indice - 1, 'prev'); });
  flechaNext.addEventListener('click', function () { irA(indice + 1, 'next'); });
  actualizarContador();
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('.mt-form-producto');
  forms.forEach(function (form) {
    var datosEl = form.querySelector('[data-mt-variantes-json]');
    if (!datosEl) return;
    var variantes;
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-mt-precio-actual]');
    var precioAntesEl = form.querySelector('[data-mt-precio-antes]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');
    var botonCarrito = form.querySelector('[data-mt-boton-carrito]');
    var aviso = form.querySelector('[data-mt-aviso-carrito]');
    var avisoTexto = aviso ? aviso.querySelector('[data-mt-aviso-texto]') : null;
    var inputCantidad = form.querySelector('input[name="quantity"]');
    var seleccionYaEnCarrito = false;
    var disponibilidadTexto = form.querySelector('[data-mt-disponibilidad-texto]');
    var disponibilidadPunto = form.querySelector('[data-mt-disponibilidad-punto]');
    var grupos = form.querySelectorAll('[data-mt-grupo-opcion]');
    var grupoTalla = form.querySelector('[data-mt-grupo-opcion][data-mt-opcion-nombre="Talla"]') ||
      form.querySelector('[data-mt-grupo-opcion][data-mt-opcion-nombre="Size"]') ||
      (grupos.length === 1 ? grupos[0] : null);
    var galeria = document.querySelector('[data-mt-galeria]');
    var principal = galeria ? galeria.querySelector('[data-mt-imagen-principal]') : null;
    var imagenesTalla = null;
    if (galeria && galeria.getAttribute('data-mt-imagenes-talla')) {
      try { imagenesTalla = JSON.parse(galeria.getAttribute('data-mt-imagenes-talla')); } catch (e) { imagenesTalla = null; }
    }

    function actualizarImagenPorTalla() {
      if (!grupoTalla || !principal || !imagenesTalla) return;
      var activa = grupoTalla.querySelector('[data-activa="true"]');
      if (!activa) return;
      var valor = activa.getAttribute('data-valor');
      var src = imagenesTalla[valor];
      if (!src || src === principal.src) return;
      principal.classList.add('mt-fundido');
      window.setTimeout(function () {
        principal.src = src;
        principal.classList.remove('mt-fundido');
      }, 200);
    }

    function opcionesSeleccionadas() {
      var seleccion = [];
      grupos.forEach(function (grupo) {
        var activa = grupo.querySelector('[data-activa="true"]');
        seleccion.push(activa ? activa.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
    }

    function formatoDinero(centavos) {
      return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      if (inputId) inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatoDinero(variante.price);
      if (precioAntesEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioAntesEl.textContent = formatoDinero(variante.compare_at_price);
          precioAntesEl.style.display = '';
        } else {
          precioAntesEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !variante.available;
        botonComprar.textContent = variante.available
          ? botonComprar.getAttribute('data-texto-disponible')
          : botonComprar.getAttribute('data-texto-agotado');
      }
      if (botonCarrito) {
        botonCarrito.disabled = !variante.available;
        botonCarrito.removeAttribute('data-anadido');
        botonCarrito.textContent = variante.available
          ? botonCarrito.getAttribute('data-texto-disponible')
          : botonCarrito.getAttribute('data-texto-agotado');
      }
      seleccionYaEnCarrito = false;
      if (disponibilidadTexto) {
        disponibilidadTexto.textContent = variante.available
          ? disponibilidadTexto.getAttribute('data-texto-disponible')
          : disponibilidadTexto.getAttribute('data-texto-agotado');
      }
      if (disponibilidadPunto) {
        disponibilidadPunto.classList.toggle('mt-producto__punto--agotado', !variante.available);
      }

      grupos.forEach(function (grupo, indiceGrupo) {
        var pastillas = grupo.querySelectorAll('[data-mt-pastilla]');
        pastillas.forEach(function (pastilla) {
          var valorPastilla = pastilla.getAttribute('data-valor');
          var seleccionSimulada = opcionesSeleccionadas();
          seleccionSimulada[indiceGrupo] = valorPastilla;
          var existe = variantes.some(function (v) {
            return v.options.every(function (op, i) {
              return seleccionSimulada[i] === null || op === seleccionSimulada[i];
            });
          });
          pastilla.disabled = !existe;
        });
      });

      actualizarImagenPorTalla();
    }

    grupos.forEach(function (grupo) {
      var pastillas = grupo.querySelectorAll('[data-mt-pastilla]');
      pastillas.forEach(function (pastilla) {
        pastilla.addEventListener('click', function () {
          if (pastilla.disabled) return;
          pastillas.forEach(function (p) { p.setAttribute('data-activa', 'false'); });
          pastilla.setAttribute('data-activa', 'true');
          actualizar();
        });
      });
    });

    function actualizarIconoCarrito(secciones) {
      var html = secciones && secciones['cart-icon-bubble'];
      var icono = document.getElementById('cart-icon-bubble');
      if (!html || !icono) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var contenido = doc.querySelector('.shopify-section');
      if (contenido) icono.innerHTML = contenido.innerHTML;
    }

    function mostrarAviso(texto, esError) {
      if (!aviso) return;
      if (avisoTexto) avisoTexto.textContent = texto;
      aviso.classList.toggle('mt-producto__aviso-carrito--error', !!esError);
      var enlace = aviso.querySelector('a');
      if (enlace) enlace.hidden = !!esError;
      aviso.hidden = false;
    }

    if (inputCantidad) {
      ['input', 'change'].forEach(function (evento) {
        inputCantidad.addEventListener(evento, function () {
          seleccionYaEnCarrito = false;
          if (botonCarrito && !botonCarrito.disabled) {
            botonCarrito.removeAttribute('data-anadido');
            botonCarrito.textContent = botonCarrito.getAttribute('data-texto-disponible');
          }
        });
      });
    }

    if (botonCarrito) {
      botonCarrito.addEventListener('click', function () {
        if (botonCarrito.disabled || !inputId) return;
        var cantidad = Math.max(1, parseInt((inputCantidad && inputCantidad.value) || '1', 10));
        botonCarrito.disabled = true;
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(inputId.value), quantity: cantidad }],
            sections: 'cart-icon-bubble',
            sections_url: window.location.pathname
          })
        })
          .then(function (r) { return r.json().then(function (datos) { return { ok: r.ok, datos: datos }; }); })
          .then(function (res) {
            botonCarrito.disabled = false;
            if (!res.ok) {
              mostrarAviso(res.datos.description || res.datos.message || 'No se pudo añadir al carrito.', true);
              return;
            }
            seleccionYaEnCarrito = true;
            botonCarrito.setAttribute('data-anadido', 'true');
            botonCarrito.textContent = botonCarrito.getAttribute('data-texto-anadido');
            actualizarIconoCarrito(res.datos.sections);
            var nombre = (res.datos.items && res.datos.items[0] && res.datos.items[0].variant_title) || '';
            mostrarAviso(cantidad + ' × Talla ' + nombre + ' añadida al carrito.', false);
          })
          .catch(function () {
            botonCarrito.disabled = false;
            mostrarAviso('No se pudo añadir al carrito. Inténtalo de nuevo.', true);
          });
      });
    }

    form.addEventListener('submit', function (e) {
      // Si la talla elegida ya se añadió con "Añadir al carrito", no la duplicamos: vamos directos al pago.
      if (seleccionYaEnCarrito) {
        e.preventDefault();
        var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        window.location.href = raiz + 'checkout';
      }
    });

    actualizar();
  });
}

function initCantidad() {
  var cajas = document.querySelectorAll('[data-mt-cantidad]');
  cajas.forEach(function (caja) {
    var input = caja.querySelector('input');
    var menos = caja.querySelector('[data-mt-menos]');
    var mas = caja.querySelector('[data-mt-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      var val = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
    if (mas) mas.addEventListener('click', function () {
      var val = parseInt(input.value || '1', 10) + 1;
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });
}
